// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"b72814d8","445":"3d571b3d","787":"1cd31a9e"}[chunkId] + ".chunk.js";
};